module.exports = __webpack_public_path__ + "img/picture1.1cb13dde.jpg";